// The existing stock endpoint owns cert corroboration. An image-only hint is
// useful to the operator, but must never classify a slab as confirmed Shopify.
const key=value=>/^\d{4,12}$/.test(String(value||''))?String(value).replace(/^0+(?=\d)/,''):null;
export function scannerShopifyIndex(stock){
 const index=new Map();if(stock?.status!=='ready')return index;
 for(const listing of stock.listings||[]){
  const exact=key(listing.certNumber),image=key(/\/(\d{4,12})[_-](?:front|back)/i.exec(listing.imageUrl||'')?.[1]);
  const cert=exact||image;if(!cert)continue;
  const confirmed=!!exact&&!listing.reviewReason&&listing.quantity===1;
  const previous=index.get(cert);
  index.set(cert,previous?{status:'review'}:{status:confirmed?'confirmed':'review',productId:listing.productId});
 }
 return index;
}
export function scannerShopifyMatch(index,cert){return index.get(key(cert))||null;}
export function scannerInventoryLabel({check,newUseLabel,existingUseLabel,shopify,shopifyStatus}){
 if(!check||check.status==='checking')return 'Checking inventory…';
 if(check.status==='error')return 'Could not check · retry needed';
 if(check.slab?.shopify?.status==='confirmed')shopify={status:'confirmed'};
 if(shopify?.status==='confirmed')return check.existing?`Already in inventory · ${existingUseLabel} · on Shopify`:'Already on Shopify · stock record added on Save';
 if(shopify?.status==='review')return check.existing?'Already in inventory · possible Shopify listing':'Possible Shopify listing · review needed';
 if(check.existing)return `Already in inventory · ${existingUseLabel}`;
 if(shopifyStatus==='loading')return 'Not yet in inventory · checking Shopify…';
 if(shopifyStatus==='unavailable')return 'Not yet in inventory · Shopify check unavailable';
 return `Not yet in inventory · ${newUseLabel} when saved`;
}
export function scannerRegistrationUse(cert,newUse,index){return scannerShopifyMatch(index,cert)?.status==='confirmed'?'shopify':newUse;}
